// Module
var code = `<div class="col-lg-12">
    <bfg-chart name="retention.RetentionByMissionChart"></bfg-chart>
</div>

<installs-table
    prec="3"
    rows="rows"
    get-players="amt.ww2.life_time.players_purchases"
>
</installs-table>
`;
// Exports
module.exports = code;